var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "color-simple",
      class: { [_vm.type]: _vm.type },
      style: { width: _vm.width }
    },
    [
      _c("div", {
        staticClass: "color-simple-color",
        style: _vm.backgroundImage
      }),
      _c("div", { staticClass: "_title" }, [_vm._v(_vm._s(_vm.unit))]),
      _c(
        "div",
        { staticClass: "color-simple-value" },
        _vm._l(_vm.orderedData, function(item, index) {
          return _c("div", { key: index }, [_vm._v(_vm._s(item))])
        }),
        0
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }